import { MinimalSpinner } from 'loading-animations-react';

export const Loading = () => {
    return (
        <div className='loading'>
            <div className='loading__spinner'>
                <MinimalSpinner color="#ffcc00" text='' />
            </div>
        </div>
        )
}